import { searchAlgoliaClient } from "shared/integrations/algolia/searchAlgoliaClient";

export const searchGamesIndex = searchAlgoliaClient.initIndex(
  process.env.REACT_APP_ALGOLIA_GAMES_INDEX_NAME ?? "",
);
